import { types } from 'actions/calendar';
import dayjs from 'dayjs';
import { getStringValue, noValue, toExcluded } from 'utils/search';

const defaultState = {
  pageSize: 50,
  pageNumber: 0,
  filters: {
    year: +dayjs().format('YYYY'),
    month: null,
    name: '',
  },
  tableSort: {
    dir: '',
    by: '',
  },
  restoringState: true,
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.SET_PAGE_SIZE:
      return {
        ...state,
        pageNumber: action.payload.number,
      };
    case types.SET_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload.number,
      };
    case types.SET_SORT: {
      const tableSort =
        action.payload.sortKey === state.tableSort.by
          ? state.tableSort.dir === 'asc'
            ? { dir: 'desc', by: state.tableSort.by }
            : defaultState.tableSort
          : { dir: 'asc', by: action.payload.sortKey };
      return {
        ...state,
        tableSort,
      };
    }
    case types.SET_FILTER: {
      const newState = { ...state.filters };
      const { id, value } = action.payload;
      if (noValue(value)) {
        delete newState[id];
      } else {
        newState[id] = value;
      }
      if (id === 'state' && value) {
        const prevStates = state.filters.state || [];
        if (value.length > prevStates?.length) {
          const currentRegionCountry = newState.regionCountry || [];
          const lastEntry = value[value.length - 1];
          if (!currentRegionCountry.includes(lastEntry.countryName)) {
            if (
              currentRegionCountry.includes(toExcluded(lastEntry.countryName))
            ) {
              newState.regionCountry = currentRegionCountry.map(x =>
                x === toExcluded(lastEntry.countryName) ? getStringValue(x) : x
              );
            } else {
              newState.regionCountry = [
                ...currentRegionCountry,
                lastEntry.countryName,
              ];
            }
          }
        }
      }
      return {
        ...state,
        filters: newState,
      };
    }
    case types.SET_FILTERS:
      return {
        ...state,
        filters: action.payload.value,
      };
    case types.RESTORE_STATE: {
      if (!action.payload) {
        return {
          ...state,
          restoringState: false,
        };
      }

      const restoredState = JSON.parse(JSON.stringify(action.payload));
      restoredState.restoringState = false;
      return restoredState;
    }
    case types.CLEAR_FILTERS:
      return { ...defaultState, restoringState: false };
    default:
      return state;
  }
};

export default reducer;
